import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { editOrderActions } from '../+state/edit-order/edit-order.actions';
import { editOrderFeature } from '../+state/edit-order/edit-order.reducers';

@Injectable({ providedIn: 'root' })
export class EditOrderFacade {
  readonly #store = inject(Store);

  public isReady$: Observable<boolean> = this.#store.select(editOrderFeature.selectIsReady);
  public orderCancelling$: Observable<boolean> = this.#store.select(editOrderFeature.selectIsCancellingOrder);
  public orderCancelTriggered$: Observable<boolean> = this.#store.select(editOrderFeature.selectIsCancellationTriggered);
  public orderCancellationDone$: Observable<boolean> = this.#store.select(editOrderFeature.selectIsCancellationDone);
  public isOutOfTradingTimes$: Observable<boolean> = this.#store.select(editOrderFeature.selectIsOutOfTradingTimes);

  public cancelOrder = (id: string) => this.#store.dispatch(editOrderActions.cancelOrder({ orderId: id }));
  public resetState = () => this.#store.dispatch(editOrderActions.clearState());
  public checkTradingTimes = (isin: string) => this.#store.dispatch(editOrderActions.checkTradingTimes({ isin }));
}
